// Author : Vishnu
// Version :0.0.1
// MODIFIED DATE: 03/09/2025
import { takeLatest, put, all, call } from 'redux-saga/effects';
import RangeLoanProposalActionTypes from './range-product-loan-proposal.types';
import {
	rangeLoanProposalListFetch,
	rangeLoanProposalCenterListFetch,
	rangeLoanCenterMemberListFetch,
	rangeLoanProductListFetch,
	rangeLoanProposalAddAPI,
	rangeLoanProposalUpdateAPI,
	rangeLoanCenterMemberLeadListFetch,
	rangeLoanIndexDetailsFetch,
	rangeLoanIndexDetailsApproval,
	rangeLoanIndexDetailsReject,
	rangeLoanIndexDetailsApprovalRevert,
} from './range-product-loan-proposal.service';
import {
	getRangeLoanPropsalListSuccess,
	getRangeLoanPropsalListFailure,
	getRangeLoanPropsalListResponseChanged,
	getRangePropsalCenterListFailure,
	getRangePropsalCenterListSuccess,
	getRangePropsalCenterListResponseChanged,
	getCenterMemberListSuccess,
	getCenterMemberListFailure,
	getCenterMemberListResponseChanged,
	getRangeProductListSuccess,
	getRangeProductListFailure,
	getRangeProductListResponseChanged,
	addRangeLoanProposalSuccess,
	addRangeLoanProposalFailure,
	addRangeLoanProposalResponseChanged,
	updateRangeLoanProposalSuccess,
	updateRangeLoanProposalFailure,
	updateRangeLoanProposalResponseChanged,
	getCenterMemberLeadListFailure,
	getCenterMemberLeadListSuccess,
	getCenterMemberLeadListResponseChanged,
	getParticularLoanIndexDetailsSuccess,
	getParticularLoanIndexDetailsFailure,
	getParticularLoanIndexDetailsResponseChanged,
	rejectRangeLoanIndexSuccess,
	rejectRangeLoanIndexFailure,
	rejectRangeLoanIndexResponseChanged,
	approveRangeLoanIndexSuccess,
	approveRangeLoanIndexFailure,
	approveRangeLoanIndexResponseChanged,
	revertApproveRangeLoanIndexSuccess,
	revertApproveRangeLoanIndexFailure,
	revertApproveRangeLoanIndexResponseChanged,
} from './range-product-loan-proposal.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START GET RANGE LOAN PROPOSAL  ******************** */
export function* rangeLoanProposalListGet({ payload }: any) {
	try {
		const key = 'GetAllBranchLoanIndexDetailsKey';
		const {
			companyID,
			loanIndexType,
			branchID,
			userID,
			inputSearch,
			userRole,
			userLevel,
			databaseName,
			userRoleID,
			centerID,
			groupID,
			limit,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			LoanIndexType: loanIndexType,
			BranchID: branchID,
			UserID: userID,
			SearchData: inputSearch,
			UserRole: userRole,
			Level: userLevel,
			DatabaseName: databaseName,
			UserRoleID: userRoleID,
			CenterID: centerID,
			GroupID: groupID,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rangeLoanProposalListFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getRangeLoanPropsalListFailure(responseData.data));
		} else {
			yield put(getRangeLoanPropsalListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getRangeLoanPropsalListFailure(error));
	}
}

export function* resetGetRangeLoanProposalListResponse() {
	yield put(getRangeLoanPropsalListResponseChanged());
}

export function* onGetRangeLoanProposal() {
	yield takeLatest(
		RangeLoanProposalActionTypes.GET_RANGE_LOAN_PROPOSAL_LIST_START,
		rangeLoanProposalListGet,
	);
}

export function* onGetRangeLoanProposalListResponseReset() {
	yield takeLatest(
		RangeLoanProposalActionTypes.GET_RANGE_LOAN_PROPOSAL_LIST_RESPONSE_RESET,
		resetGetRangeLoanProposalListResponse,
	);
}
/** *********************  END GET RANGE LOAN PROPOSAL ******************** */

/** *********************  START GET RANGE LOAN PROPOSAL CENTER LIST  ******************** */
export function* rangeLoanProposalCenterListGet({ payload }: any) {
	try {
		const key = 'GetRangeLoanProposalCenterListKey';
		const { companyID, userLevel, databaseName, userID, userRole, branchID } = payload;
		const jsonData = {
			CompanyID: companyID,
			Level: userLevel,
			DatabaseName: databaseName,
			UserID: userID,
			UserRole: userRole,
			BranchID: branchID,
			IsNoLoanCenter: 0,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rangeLoanProposalCenterListFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getRangePropsalCenterListFailure(responseData.data));
		} else {
			yield put(getRangePropsalCenterListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getRangePropsalCenterListFailure(error));
	}
}

export function* resetGetRangeLoanProposalCenterListResponse() {
	yield put(getRangePropsalCenterListResponseChanged());
}

export function* onGetRangeLoanProposalCenters() {
	yield takeLatest(
		RangeLoanProposalActionTypes.GET_RANGE_LOAN_PROPOSAL_CENTER_LIST_START,
		rangeLoanProposalCenterListGet,
	);
}

export function* onGetRangeLoanProposalCenterListResponseReset() {
	yield takeLatest(
		RangeLoanProposalActionTypes.GET_RANGE_LOAN_PROPOSAL_CENTER_LIST_RESPONSE_RESET,
		resetGetRangeLoanProposalCenterListResponse,
	);
}
/** *********************  END GET RANGE LOAN PROPOSAL CENTER LIST ******************** */

/** *********************  START GET CENTER MEMBER LIST  ******************** */
export function* rangeLoanCenterMemberListGet({ payload }: any) {
	try {
		const key = 'GetMemberDetailsForCenterLoanKey';
		const { companyID, databaseName, centerID, groupID, searchData, limit } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			CenterID: centerID,
			GroupID: groupID,
			SearchData: searchData,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rangeLoanCenterMemberListFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getCenterMemberListFailure(responseData.data));
		} else {
			yield put(getCenterMemberListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCenterMemberListFailure(error));
	}
}

export function* resetGetRangeLoanCenterMemberListResponse() {
	yield put(getCenterMemberListResponseChanged());
}

export function* onGetRangeLoanCenterMembers() {
	yield takeLatest(
		RangeLoanProposalActionTypes.GET_CENTER_MEMBER_LIST_START,
		rangeLoanCenterMemberListGet,
	);
}

export function* onGetRangeLoanCenterMemberListResponseReset() {
	yield takeLatest(
		RangeLoanProposalActionTypes.GET_CENTER_MEMBER_LIST_RESPONSE_RESET,
		resetGetRangeLoanCenterMemberListResponse,
	);
}
/** *********************  END GET CENTER MEMBER LIST ******************** */

/** *********************  START GET RANGE PRODUCT LIST  ******************** */
export function* rangeLoanProductListGet({ payload }: any) {
	try {
		const key = 'GetRangeLoanProposalProductListKey';
		const { companyID, databaseName, loanType } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			ProductType: loanType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rangeLoanProductListFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getRangeProductListFailure(responseData.data));
		} else {
			yield put(getRangeProductListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getRangeProductListFailure(error));
	}
}

export function* resetGetRangeLoanProductListResponse() {
	yield put(getRangeProductListResponseChanged());
}

export function* onGetRangeLoanProductList() {
	yield takeLatest(
		RangeLoanProposalActionTypes.GET_RANGE_PRODUCT_LIST_START,
		rangeLoanProductListGet,
	);
}

export function* onGetRangeLoanProductListResponseReset() {
	yield takeLatest(
		RangeLoanProposalActionTypes.GET_RANGE_PRODUCT_LIST_RESPONSE_RESET,
		resetGetRangeLoanProductListResponse,
	);
}
/** *********************  END GET RANGE PRODUCT LIST ******************** */

/** *********************  START ADD RANGE LOAN PROPOSAL  ******************** */
export function* rangeLoanProposalAdd({ payload }: any) {
	try {
		const key = 'AddRangeLoanProposaltKey';
		const {
			companyID,
			databaseName,
			areaID,
			branchID,
			loanProposalDate,
			meetUpLocation,
			meetUpTime,
			hoLoanID,
			memberMeetupLat,
			memberMeetupLong,
			userID,
			loanIndexGroupMember,
			productInvestorDetails,
			funderName,
			totalLoanAmount,
			loanType,
			loanOfficerID,
			memberLeadID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			AreaID: areaID,
			BranchID: branchID,
			LoanProposalDate: loanProposalDate,
			MeetUpLocation: meetUpLocation,
			MeetUpTime: meetUpTime,
			HOLoanID: hoLoanID,
			MemberMeetupLat: memberMeetupLat,
			MemberMeetupLong: memberMeetupLong,
			CreatedUser: userID,
			LoanIndexType: 'Range',
			LoanIndexGroupMember: loanIndexGroupMember,
			ProductInvestorDetails: productInvestorDetails,
			FunderName: funderName,
			TotalLoanAmount: totalLoanAmount,
			LoanType: loanType,
			LoanOfficerID: loanOfficerID,
			memberLeadID: memberLeadID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rangeLoanProposalAddAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addRangeLoanProposalFailure(responseData.data));
		} else {
			yield put(addRangeLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addRangeLoanProposalFailure(error));
	}
}

export function* resetAddRangeLoanProposalResponse() {
	yield put(addRangeLoanProposalResponseChanged());
}

export function* onAddRangeLoanProposal() {
	yield takeLatest(
		RangeLoanProposalActionTypes.ADD_RANGE_LOAN_PROPOSAL_START,
		rangeLoanProposalAdd,
	);
}

export function* onAddRangeLoanProposalResponseReset() {
	yield takeLatest(
		RangeLoanProposalActionTypes.ADD_RANGE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetAddRangeLoanProposalResponse,
	);
}
/** *********************  END ADD RANGE LOAN PROPOSAL ******************** */

/** *********************  START UPDATE RANGE LOAN PROPOSAL  ******************** */
export function* rangeLoanProposalUpdate({ payload }: any) {
	try {
		const key = 'UpdateRangeLoanProposaltKey';
		const {
			userID,
			companyID,
			databaseName,
			areaID,
			branchID,
			loanProposalDate,
			meetUpLocation,
			meetUpTime,
			hoLoanID,
			memberMeetupLat,
			memberMeetupLong,
			loanIndexID,
			loanIndexGroupMember,
			productInvestorDetails,
			funderName,
			totalLoanAmount,
			loanType,
			loanOfficerID,
			memberLeadID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			AreaID: areaID,
			BranchID: branchID,
			LoanProposalDate: loanProposalDate,
			MeetUpLocation: meetUpLocation,
			MeetUpTime: meetUpTime,
			HOLoanID: hoLoanID,
			MemberMeetupLat: memberMeetupLat,
			MemberMeetupLong: memberMeetupLong,
			CreatedUser: userID,
			LoanIndexType: 'Range',
			LoanIndexID: loanIndexID,
			LoanIndexGroupMember: loanIndexGroupMember,
			ProductInvestorDetails: productInvestorDetails,
			FunderName: funderName,
			TotalLoanAmount: totalLoanAmount,
			LoanType: loanType,
			LoanOfficerID: loanOfficerID,
			memberLeadID: memberLeadID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rangeLoanProposalUpdateAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateRangeLoanProposalFailure(responseData.data));
		} else {
			yield put(updateRangeLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateRangeLoanProposalFailure(error));
	}
}

export function* resetUpdateRangeLoanProposalResponse() {
	yield put(updateRangeLoanProposalResponseChanged());
}

export function* onUpdateRangeLoanProposal() {
	yield takeLatest(
		RangeLoanProposalActionTypes.UPDATE_RANGE_LOAN_PROPOSAL_START,
		rangeLoanProposalUpdate,
	);
}

export function* onUpdateRangeLoanProposalResponseReset() {
	yield takeLatest(
		RangeLoanProposalActionTypes.UPDATE_RANGE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetUpdateRangeLoanProposalResponse,
	);
}
/** *********************  END UPDATE RANGE LOAN PROPOSAL ******************** */

/** *********************  START GET CENTER MEMBER LEAD LIST  ******************** */
export function* rangeLoanCenterMemberLeadListGet({ payload }: any) {
	try {
		const key = 'GetMemberLeadListKey';
		const { companyID, databaseName, centerID, groupID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			CenterID: centerID,
			GroupID: groupID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rangeLoanCenterMemberLeadListFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getCenterMemberLeadListFailure(responseData.data));
		} else {
			yield put(getCenterMemberLeadListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCenterMemberLeadListFailure(error));
	}
}

export function* resetGetRangeLoanCenterMemberLeadListResponse() {
	yield put(getCenterMemberLeadListResponseChanged());
}

export function* onGetRangeLoanCenterMembersLead() {
	yield takeLatest(
		RangeLoanProposalActionTypes.GET_CENTER_MEMBER_LEAD_LIST_START,
		rangeLoanCenterMemberLeadListGet,
	);
}

export function* onGetRangeLoanCenterMemberLeadListResponseReset() {
	yield takeLatest(
		RangeLoanProposalActionTypes.GET_CENTER_MEMBER_LEAD_LIST_RESPONSE_RESET,
		resetGetRangeLoanCenterMemberLeadListResponse,
	);
}
/** *********************  END GET CENTER MEMBER LEAD LIST ******************** */

/** *********************  START GET PARTICULAR LOAN INDEX DETAILS  ******************** */
export function* rangeLoanIndexDetailsGet({ payload }: any) {
	try {
		const key = 'GetParticularRangeLoanIndexKey';
		const { companyID, databaseName, loanIndexID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			LoanIndexID: loanIndexID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rangeLoanIndexDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularLoanIndexDetailsFailure(responseData.data));
		} else {
			yield put(getParticularLoanIndexDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularLoanIndexDetailsFailure(error));
	}
}

export function* resetGetRangeLoanIndexDetailsResponse() {
	yield put(getParticularLoanIndexDetailsResponseChanged());
}

export function* onGetRangeLoanIndexDetails() {
	yield takeLatest(
		RangeLoanProposalActionTypes.GET_PARTICULAR_LOAN_INDEX_DETAILS_START,
		rangeLoanIndexDetailsGet,
	);
}

export function* onGetRangeLoanIndexDetailsResponseReset() {
	yield takeLatest(
		RangeLoanProposalActionTypes.GET_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_RESET,
		resetGetRangeLoanIndexDetailsResponse,
	);
}
/** *********************  END GET PARTICULAR LOAN INDEX DETAILS ******************** */

/** *********************  START APPROVE RANGE LOAN INDEX  ******************** */
export function* rangeLoanIndexApprove({ payload }: any) {
	try {
		const key = 'ApproveRangeLoanIndexKey';
		const {
			companyID,
			databaseName,
			loanIndexID,
			userID,
			userName,
			appraisalLevel,
			appraisalDoneBy,
			appraisalDoneByUserName,
			appraisalApproveSetupID,
			appraisalApproveID,
			isAppraisalApproveNeeded,
			isAllAppraisalApproved,
			noOfAppraisalApproval,
			appraisalApproveDoneCount,
			appraisalNotes,
			loanApproveStatus,
			approveotp,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			LoanIndexID: loanIndexID,
			UserID: userID,
			UserName: userName,
			AppraisalLevel: appraisalLevel,
			AppraisalDoneBy: appraisalDoneBy,
			AppraisalDoneByUserName: appraisalDoneByUserName,
			AppraisalApproveSetupID: appraisalApproveSetupID,
			AppraisalApproveID: appraisalApproveID,
			IsAppraisalApproveNeeded: isAppraisalApproveNeeded,
			IsAllAppraisalApproved: isAllAppraisalApproved,
			NoOfAppraisalApproval: noOfAppraisalApproval,
			AppraisalApproveDoneCount: appraisalApproveDoneCount,
			AppraisalNotes: appraisalNotes,
			LoanApproveStatus: loanApproveStatus,
			Approveotp: approveotp,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rangeLoanIndexDetailsApproval, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(approveRangeLoanIndexFailure(responseData.data));
		} else {
			yield put(approveRangeLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(approveRangeLoanIndexFailure(error));
	}
}

export function* resetApproveRangeLoanIndexDetailsResponse() {
	yield put(approveRangeLoanIndexResponseChanged());
}

export function* onApproveRangeLoanIndexDetails() {
	yield takeLatest(
		RangeLoanProposalActionTypes.APPROVE_RANGE_LOAN_PROPOSAL_START,
		rangeLoanIndexApprove,
	);
}

export function* onApproveRangeLoanIndexDetailsResponseReset() {
	yield takeLatest(
		RangeLoanProposalActionTypes.APPROVE_RANGE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetApproveRangeLoanIndexDetailsResponse,
	);
}
/** *********************  END APPROVE RANGE LOAN INDEX ******************** */

/** *********************  START REVERT APPROVED RANGE LOAN INDEX  ******************** */
export function* rangeLoanIndexApproveRevert({ payload }: any) {
	try {
		const key = 'ApproveRevertRangeLoanIndexKey';
		const {
			companyID,
			databaseName,
			userID,
			userName,
			loanIndexID,
			appraisalLevel,
			appraisalDoneBy,
			appraisalDoneByUserName,
			appraisalApproveSetupID,
			appraisalApproveID,
			isAppraisalApproveNeeded,
			noOfAppraisalApproval,
			appraisalApproveDoneCount,
			appraisalNotes,
			loanApproveStatus,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			LoanIndexID: loanIndexID,
			UserID: userID,
			UserName: userName,
			AppraisalLevel: appraisalLevel,
			AppraisalDoneBy: appraisalDoneBy,
			AppraisalDoneByUserName: appraisalDoneByUserName,
			AppraisalApproveSetupID: appraisalApproveSetupID,
			AppraisalApproveID: appraisalApproveID,
			IsAppraisalApproveNeeded: isAppraisalApproveNeeded,
			NoOfAppraisalApproval: noOfAppraisalApproval,
			AppraisalApproveDoneCount: appraisalApproveDoneCount,
			AppraisalNotes: appraisalNotes,
			LoanApproveStatus: loanApproveStatus,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rangeLoanIndexDetailsApprovalRevert, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertApproveRangeLoanIndexFailure(responseData.data));
		} else {
			yield put(revertApproveRangeLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertApproveRangeLoanIndexFailure(error));
	}
}

export function* resetApproveRevertRangeLoanIndexDetailsResponse() {
	yield put(revertApproveRangeLoanIndexResponseChanged());
}

export function* onApproveRevertRangeLoanIndexDetails() {
	yield takeLatest(
		RangeLoanProposalActionTypes.REVERT_APPROVED_RANGE_LOAN_PROPOSAL_START,
		rangeLoanIndexApproveRevert,
	);
}

export function* onApproveRevertRangeLoanIndexDetailsResponseReset() {
	yield takeLatest(
		RangeLoanProposalActionTypes.REVERT_APPROVED_RANGE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetApproveRevertRangeLoanIndexDetailsResponse,
	);
}
/** *********************  END REVERT APPROVED RANGE LOAN INDEX ******************** */

/** *********************  START REJECT RANGE LOAN INDEX  ******************** */
export function* rangeLoanIndexReject({ payload }: any) {
	try {
		const key = 'RejectRangeLoanIndexKey';
		const { companyID, databaseName, LoanIndexID } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			LoanIndexID: LoanIndexID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(rangeLoanIndexDetailsReject, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(rejectRangeLoanIndexFailure(responseData.data));
		} else {
			yield put(rejectRangeLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(rejectRangeLoanIndexFailure(error));
	}
}

export function* resetRejectRangeLoanIndexDetailsResponse() {
	yield put(rejectRangeLoanIndexResponseChanged());
}

export function* onRejectRangeLoanIndexDetails() {
	yield takeLatest(
		RangeLoanProposalActionTypes.REJECT_RANGE_LOAN_PROPOSAL_START,
		rangeLoanIndexReject,
	);
}

export function* onRejectRangeLoanIndexDetailsResponseReset() {
	yield takeLatest(
		RangeLoanProposalActionTypes.REJECT_RANGE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetRejectRangeLoanIndexDetailsResponse,
	);
}
/** *********************  END REJECT RANGE LOAN INDEX ******************** */

export function* rangeLoanProposalSaga() {
	yield all([
		call(onGetRangeLoanProposal),
		call(onGetRangeLoanProposalListResponseReset),
		call(onGetRangeLoanProposalCenters),
		call(onGetRangeLoanProposalCenterListResponseReset),
		call(onGetRangeLoanCenterMembers),
		call(onGetRangeLoanCenterMemberListResponseReset),
		call(onGetRangeLoanProductList),
		call(onGetRangeLoanProductListResponseReset),
		call(onAddRangeLoanProposal),
		call(onAddRangeLoanProposalResponseReset),
		call(onUpdateRangeLoanProposal),
		call(onUpdateRangeLoanProposalResponseReset),
		call(onGetRangeLoanCenterMembersLead),
		call(onGetRangeLoanCenterMemberLeadListResponseReset),
		call(onGetRangeLoanIndexDetails),
		call(onGetRangeLoanIndexDetailsResponseReset),
		call(onApproveRangeLoanIndexDetails),
		call(onApproveRangeLoanIndexDetailsResponseReset),
		call(onRejectRangeLoanIndexDetails),
		call(onRejectRangeLoanIndexDetailsResponseReset),
		call(onApproveRevertRangeLoanIndexDetails),
		call(onApproveRevertRangeLoanIndexDetailsResponseReset),
	]);
}
